module.exports = __webpack_public_path__ + "static/media/RR-Pride-2.bfff849b.jpeg";